import React, { Component } from 'react';
import _ from 'lodash';

import ImportFilePreviewComponent from './../components/ImportFilePreview';
import { ImportExportItemsEnum } from 'Common/FieldEnum';

class ImportFilePreview extends Component {
  state = {
    error: false,
  };

  addData = (event, { value }, i) => {
    this.setState({ error: !this.props.updatePreviewData(value, i) });
  };

  getValue = index => {
    const { header, options } = this.props;

    if (header.length) {
      const match = header.find(
        x => x[ImportExportItemsEnum.ColumnNumber] === index
      );

      if (match) {
        const optionMatch = options.find(x => {
          return x.value === match[ImportExportItemsEnum.FieldName];
        });
        if (optionMatch) return optionMatch;
      }
    }
    return {
      value: -1,
      key: 'skip',
      text: 'Skip',
    };
  };
  getPreparedData = () => {
    const keyValues = this.props.fileData && this.props.fileData[0];
    const { fileData = [] } = this.props;
    let finalObj = {};
    const finalList = [];
    if (fileData.length) {
      for (let i = 0; i < fileData.length; i++) {
        for (let j = 0; j < fileData[i].length; j++) {
          if (finalList.length < fileData.length) {
            for (let k = 0; k < keyValues.length; k++) {
              finalObj[`${'row' + k}`] = fileData[j][k];
            }
            finalList.push(finalObj);
            finalObj = {};
          }
        }
      }
    }
    return finalList;
  };

  getColumns = () => {
    let columns = [];

    const keyValues = this.props.fileData && this.props.fileData[0];
    const { header } = this.props;
    const highestColumnNumber = _.maxBy(header, y => {
      return y[ImportExportItemsEnum.ColumnNumber];
    })
      ? _.maxBy(header, y => {
          return y[ImportExportItemsEnum.ColumnNumber];
        })[ImportExportItemsEnum.ColumnNumber]
      : 0;

    if (keyValues && keyValues.length > highestColumnNumber) {
      columns = keyValues;
    } else if (keyValues && keyValues.length < highestColumnNumber) {
      for (let i = 0; i <= highestColumnNumber; i++) {
        columns.push('column' + i);
      }
    } else if (keyValues && keyValues.length === highestColumnNumber) {
      columns = keyValues;
    }
    return columns;
  };

  render() {
    return (
      <ImportFilePreviewComponent
        keyValues={this.props.fileData && this.props.fileData[0]}
        getPreparedData={this.getPreparedData}
        columns={this.getColumns()}
        options={this.props.options}
        error={this.state.error}
        getValue={this.getValue}
        addData={this.addData}
      />
    );
  }
}

export default ImportFilePreview;



// WEBPACK FOOTER //
// ./src/pages/utilities/importexport/importInventory/containers/ImportFilePreview.js